var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"showLanguageBar":true}}),(_vm.moduleIsReady)?_c('div',[_c('BodyPage')],1):_c('div',[_vm._v("Loading profile...")]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }